/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { selectCurrentModel } from "data/store/reducers/model";
import { useMemo } from "react";
import { useSelector } from "react-redux";
// import { Logger } from "cms/utils/log/logger";

const useModelNamedComponentsField = (fieldName) => {
    // Logger.info("Get Content Components:");
    const model = useSelector(selectCurrentModel);

    // memoize this operation to prevent log spam and improve performance
    const namedComponents = useMemo(() => {
        const result = getNamedComponentsFromModel(model, fieldName);
        return result;
    }, [fieldName, model]);
    // Logger.flush()
    return namedComponents;
};

/**
 * @param {import('data/store/reducers/model/model.state').Model} model
 * @param {string} fieldName 
 * @returns {Array<{guid?: string}>}
 */
export function getNamedComponentsFromModel (model, fieldName) {
    let components = [];
    if (model && fieldName) {
        const fields = model.fields;
        const field = fields && fields.find((element) => element.name === fieldName);
        if (field) {
            components = field.values[0]?.value;
            components = structuredClone(components);
        }
    }
    // const count = components.length
    // Logger.debug(`namedComponents: number of components for field [${fieldName}]: [${count}]`, {components})
    // Logger.flush()
    return components;
}

export { useModelNamedComponentsField };
